export enum HUSDAirdropTab {
  Instruction = 1,
  Summary = 2,
}
